import { Routes } from '@angular/router';

export const routes: Routes = [

  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/billing-subscription/billing-subscription.page').then(m => m.BillingSubscriptionPage)
      }
    ]
  }
];
